import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import chooseInterest from "../utils/interests function";

export default function CategCheckbox({
  categ,
  userId,
  userData,
  realTimeData,
}) {
  return (
    <button
      className="categ-checkbox-wrapper"
      onClick={() => chooseInterest(categ, userId, userData)}
    >
      {realTimeData.interests?.includes(categ) ? (
        <CheckIcon
          sx={{
            fontSize: "1.2rem",
            color: "rgb(255, 201, 26)",
            color: "rgb(9, 30, 43)",
            pointerEvents: "none",
          }}
        />
      ) : null}
    </button>
  );
}
